import * as React from "react"
import {SelectSeeker} from "@ui-seeker/core"
import {VIEW_DATA} from "./@constants";



const OPTIONS = [
    { label: 'Top 5 Retailers', value: VIEW_DATA.TOP_RETAILERS },
    { label: 'Average Market Price', value: VIEW_DATA.AVG_MARKET },
]

export default function PricingSkuEvolutionViewDataSelect({ viewData, onChange }) {

    return <SelectSeeker
        options={OPTIONS}
        label="View Data"
        value={viewData}
        onChange={e => onChange(e.target.value)}
    />
}